module.exports = __webpack_public_path__ + "static/media/task1Planet3.6472ad6b.png";